import { MIMETYPE_CSV } from '@disy/lib/media-type';

import { AbstractDataViewExportAction } from 'cadenza/actions/table/abstract-data-view-export-action';
import type { ExportActionContext } from 'cadenza/workbook/actions/export-actions';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';

import i18n from './export-to-csv-action.properties';

export class ExportToCsvAction extends AbstractDataViewExportAction {
  constructor(dataViewId: DataViewId, actionContext: ExportActionContext) {
    super(dataViewId, actionContext, MIMETYPE_CSV, {
      label: i18n('action.label'),
      dialogTitle: i18n('dialog.title'),
    });
  }

  override get enabledSync() {
    return true;
  }
}
